import { inject, Injectable, Query } from "@angular/core";
import { collection, collectionSnapshots, doc, docSnapshots, DocumentData, FieldPath, Firestore, query, where, WhereFilterOp, writeBatch } from "@angular/fire/firestore";
import { take } from "rxjs";

@Injectable({ providedIn: 'root' })
export class FireHelper {
  private db: Firestore = inject(Firestore)


  batchUpdate(items: Array<any>) {
      const batch = writeBatch(this.db);
      for (let i = 0; i < items.length; i++) {
          const ref = doc(this.db,items[i].ref);
          if(items[i].is_new){
            batch.set(ref, items[i].data, {merge:true})
          }else{
            batch.update(ref, items[i].data);
          }
      }
      return batch.commit();
  }

  batchDeleteWhere(path: string, whereCriterias:[string | FieldPath, WhereFilterOp, unknown][]){
    const q = query(collection(this.db, path), ...whereCriterias.map((criteria: [string | FieldPath, WhereFilterOp, unknown]) => where(...criteria)));
    collectionSnapshots(q).pipe(take(1)).subscribe(items => {
      const batch = writeBatch(this.db);
      for (let i = 0; i < items.length; i++) {
          batch.delete(items[i].ref);
      }
      return batch.commit();
    })
  }
}